import { ApplicationRef, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';

import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';

import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';

@NgModule({
    imports: [BrowserModule, ConfigModule, NavigationModule, StoreModule.forRoot({})],
})
export class StaticPageModule {
    ngDoBootstrap(appRef: ApplicationRef): void {
        appRef.bootstrap(TopBarNavComponent);
    }
}
